import React, { useState } from 'react';

import Button from 'components/DesignSystem/Button';
import ConfirmationButton from 'components/ConfirmationButton';

import './index.scss';

export interface EditRowProps {
  name: string;
  caption?: string;
  idPrefix: string;
  onEdit: (name: string) => void;
  onDelete: () => void;
  confirmationBody: React.ReactNode;
}

export default function Row({
  name,
  caption,
  idPrefix,
  onEdit,
  onDelete,
  confirmationBody,
}: EditRowProps) {
  const [editMode, setEditMode] = useState(false);
  const [newName, setNewName] = useState(name);

  const save = () => {
    setEditMode(false);
    onEdit(newName);
  };

  const cancel = () => {
    setEditMode(false);
    setNewName(name);
  };

  return (
    <div className="edit-sheet-row">
      <div className="edit-sheet-row-text">
        {editMode ? (
          <input
            className="edit-sheet-row-input"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
          />
        ) : (
          <>
            <span className="edit-sheet-row-name">{name}</span>
            {caption && <span className="edit-sheet-row-caption">{caption}</span>}
          </>
        )}
      </div>
      <div className="edit-sheet-row-actions">
        {editMode ? (
          <>
            <Button type="secondary" small icon="checkmark" onClick={save} id={`save-${idPrefix}`} />
            <Button type="secondary" small icon="close" onClick={cancel} id={`cancel-${idPrefix}`} />
          </>
        ) : (
          <>
            <Button type="secondary" small icon="edit" onClick={() => setEditMode(true)} id={`edit-${idPrefix}`} />
            <ConfirmationButton
              type="secondary"
              small
              icon="close"
              onClick={onDelete}
              confirmationBody={confirmationBody}
              id={`delete-${idPrefix}`}
            />
          </>
        )}
      </div>
    </div>
  );
}
